import { render, staticRenderFns } from "./PersonaGridSection.vue?vue&type=template&id=fcff3f8e"
import script from "./PersonaGridSection.vue?vue&type=script&lang=ts"
export * from "./PersonaGridSection.vue?vue&type=script&lang=ts"
import style0 from "./PersonaGridSection.vue?vue&type=style&index=0&id=fcff3f8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports